import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { StoreService } from '@pc-services';

@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'pcTicketLocation',
})
export class PcTicketLocationPipe implements PipeTransform {
  constructor(private store: StoreService) {}

  public transform(locationId: string | undefined | null): string | undefined {
    if (!locationId) {
      return undefined;
    }

    return this.store.ticketLocations
      .getValue()
      ?.find((location) => location.uid === locationId)?.name;
  }
}
